import React from 'react';
import Card from './Card';
import { ArrowLeftIcon, SparklesIcon } from './Icons';

interface ComingSoonProps {
    onBack: () => void;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ onBack }) => {
  return (
    <div>
        <button onClick={onBack} className="flex items-center space-x-2 text-sm font-medium text-gray-600 hover:text-gray-900 mb-6">
            <ArrowLeftIcon className="h-5 w-5" />
            <span>Quay lại</span>
        </button>
        <div className="flex justify-center items-center py-16">
            <Card className="max-w-lg w-full text-center p-10">
                <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-blue-100">
                    <SparklesIcon className="h-6 w-6 text-blue-600" />
                </div>
                <h2 className="mt-6 text-2xl font-bold text-gray-900">Tính năng sắp ra mắt!</h2>
                <p className="mt-2 text-gray-600">
                    Chúng tôi đang làm việc chăm chỉ để mang tính năng tuyệt vời này đến với bạn. Vui lòng quay lại sau!
                </p>
            </Card>
        </div>
    </div>
  );
};

export default ComingSoon;
